import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyIntegration } from '../../../interfaces/restaurant';

@Component({
  selector: 'app-restaurant-integrations',
  templateUrl: './restaurant-integrations.component.html',
  styleUrls: ['./restaurant-integrations.component.scss']
})
export class RestaurantIntegrationsComponent {
  @Input() integrations: AnyIntegration[] = [];
  @Input() editable = false;
  @Input() isAvailable = false;

  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<string>();
}
